/* global mapboxgl */
import React from 'react'
import ReactDOM from 'react-dom'
import styles from './MapboxDivOverlay.scss'
import { onMapboxReady } from 'lib/mapboxUtils'

export class MapboxDivOverlay extends React.PureComponent {
  constructor (props) {
    super(props)
    this._container = document.createElement('div')
    this._container.style.cssText = `z-index: ${props.zIndex === undefined ? 1 : props.zIndex}`
  }

  componentDidMount () {
    const { mapInstance } = this.props
    onMapboxReady(mapInstance, this.addToMap)
  }

  componentDidUpdate () {
    const { mapInstance, position } = this.props
    onMapboxReady(mapInstance, () => {
      this._marker.setLngLat(position)
    })
  }

  componentWillUnmount () {
    this._marker && this._marker.remove()
  }

  addToMap = () => {
    const { mapInstance, position, offset, autoPan } = this.props
    this._marker = new mapboxgl.Marker({
      element: this._container,
      anchor: 'bottom',
      offset: offset
    }).setLngLat(position).addTo(mapInstance)

    if (autoPan) {
      // this differs from the Google implementation in that it centers an
      // autoPan'd box, but it's actually kind of nice with the smooth mapbox
      // transistions? We could definitely re-implement all the offset
      // calculation that GoogleDivOverlay does if required, but I really
      // don't mind this implementation at all from a UX perspective.
      mapInstance.panTo(position, {
        padding: {
          top: 20,
          bottom: 20,
          left: 20,
          right: 20
        }
      })
    }
  }

  render () {
    const { children } = this.props
    return ReactDOM.createPortal(
      <div className={styles.MapboxDivOverlay}>{children}</div>,
      this._container
    )
  }
}
